import { MedicationEntry } from '../types/records'

export function loadDemoMedications(): MedicationEntry[] {
  return [
    {
      id: '1',
      user_id: 'demo-user-id',
      name: 'Metformin',
      dosage: '500mg',
      frequency: 'Twice daily',
      instructions: 'Take with meals',
      start_date: '2022-03-15',
      is_active: true,
      adherence_percentage: 95,
      created_at: '2022-03-15T00:00:00Z',
      updated_at: '2024-01-15T00:00:00Z'
    }
  ];
}
